var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"panel-group"},[_c('Backlog',{attrs:{"amvans":_vm.amvans}}),_vm._v(" "),_c('Todo',{attrs:{"amvans":_vm.amvans}}),_vm._v(" "),_c('Doing',{attrs:{"amvans":_vm.amvans}}),_vm._v(" "),_c('Done',{attrs:{"amvans":_vm.amvans}})],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db50f6a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AmvanPage.vue
// module id = null
// module chunks = 